import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { requestWithStatusHandling } from './api-status-handler';

export const addSpecDocument = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.MEASUREMENT.UPLOAD_DOCUMENT}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeasurementDocument = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.MEASUREMENT.GET_DOCUMENT_LIST}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateMeasurementDocuments = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MEASUREMENT.UPDATE_DOCUMENT}/${payload?.docId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMeasurementDocument = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.MEASUREMENT.DELETE_DOCUMENT}`, {
      data: { deletedData: payload },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDocumentStatus = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.MEASUREMENT.UPDATE_DOCUMENT_STATUS}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDevOrderGradingGroups = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.MEASUREMENT.GET_DEV_ORDER_GRADING_GROUPS}`, { params: { ...payload } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDevOrderGradingGroups = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MEASUREMENT.UPDATE_DEV_ORDER_GRADING_GROUPS}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateProductIdentifier = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MEASUREMENT.UPDATE_PRODUCT_IDENTIFIER}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSampleSizeChanged = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MEASUREMENT.UPDATE_SAMPLE_SIZE_CHANGED}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateHiddenSizes = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MEASUREMENT.UPDATE_HIDDEN_SIZES}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSampleSizeName = async (payload) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'get',
      url: `${apiEndpoint}${API.MEASUREMENT.GET_SAMPLE_SIZE_NAME}`,
      params: { devOrderId: payload },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};
